"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PersonalInfoForm = _interopRequireDefault(require("./PersonalInfoForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _PersonalInfoForm.default;
exports.default = _default;